/* UnoKeeper — instrumentación propia de intención (bloque 16, 2026-09-10).
   - Una sola ruta por evento: gtag si existe, si no dataLayer (nunca ambos). Clarity solo recibe un tag.
   - Consentimiento coherente con el modelo de la tienda (opt-out LFPDPPP): un RECHAZO explícito
     (localStorage del banner o uk:consent-updated) apaga los eventos de inmediato; si la Customer
     Privacy API de Shopify ya cargó, manda su respuesta (analyticsProcessingAllowed).
   - No envía nombres de personalización, teléfonos, query de búsqueda ni texto de errores.
   - add_to_cart_success / add_to_cart_error salen de la respuesta REAL de /cart/add
     (uk:cart-add-result, emitido por theme.js y cart-upsell.js), no del clic. Nunca emite purchase.
   - H03 (auditoría 11-sep-2026): el clic de intención se captura en WINDOW (fase de captura) para que
     ningún manejador del documento (cart-upsell.js deshabilita su botón antes de la petición) lo oculte;
     el botón real del upsell (data-cart-upsell-add) entra en la misma ruta de atc_click, y la barra
     fija conserva su origen hasta el resultado vía data-uk-atc-source (cart-bar.js → theme.js).
   - No reemplaza los píxeles nativos de Shopify ni los eventos de ecommerce. */
(function () {
  'use strict';
  if (window.__ukEventsInit) return;
  window.__ukEventsInit = true;
  var tpl = (document.querySelector('[data-uk-events-template]') || {}).dataset;
  tpl = tpl && tpl.ukEventsTemplate ? tpl.ukEventsTemplate : 'storefront';
  var consentUpdate = null; // última decisión tomada en esta página (uk:consent-updated)
  function storedPrefs() {
    try {
      var stored = JSON.parse(localStorage.getItem('uk_cookie_consent_v1') || 'null');
      if (stored && stored.expires > Date.now() && stored.prefs) return stored.prefs;
    } catch (e) {}
    return null;
  }
  function analyticsAllowed() {
    if (consentUpdate === false) return false;
    var p = storedPrefs();
    if (p && p.analytics === false) return false;               // rechazo explícito guardado
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() === true;
    } catch (e) {}
    return true; // sin decisión y sin API aún: modelo opt-out de la tienda (igual que Clarity/GA)
  }
  var allowedEvents = ['whatsapp_click','size_finder_use','atc_click','perso_toggle_open','inapp_browser','select_size','size_unavailable','view_size_guide','personalization_complete','add_to_cart_success','add_to_cart_error','cartbar_size_prompt','cartbar_soldout_tap','alternative_click'];
  var allowedParams = ['source','value','size','variant_id','product_id','quantity','status','method','available','inapp'];
  function track(name, params) {
    if (allowedEvents.indexOf(name) === -1 || !analyticsAllowed()) return false;
    var safe = {};
    Object.keys(params || {}).forEach(function (key) {
      if (allowedParams.indexOf(key) === -1) return;
      var value = params[key];
      if (typeof value === 'number' || typeof value === 'boolean') safe[key] = value;
      else if (typeof value === 'string') safe[key] = value.slice(0, 80);
    });
    // Una ruta de analítica por evento: gtag O dataLayer, no los dos.
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, safe);
      else if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, safe));
    } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('set', name, String(safe.source || safe.size || '1')); } catch (e) {}
    return true;
  }
  window.ukTrack = track;

  // Auditoría sep-2026 #48: etiquetar in-app browser (FB/IG/Threads). Solo etiqueta; no toca píxeles.
  var inapp = /FBAN|FBAV|FB_IAB|FB4A|Instagram|Threads/i.test(navigator.userAgent) ? '1' : '0';
  document.documentElement.setAttribute('data-uk-inapp', inapp);
  var sentInapp = false;
  function tagInapp() {
    if (sentInapp || !analyticsAllowed()) return;
    // Espera a que exista un receptor: tener este código no es entrega en GA4.
    if (typeof window.gtag !== 'function' && !Array.isArray(window.dataLayer)) return;
    sentInapp = track('inapp_browser', { inapp: inapp });
  }
  document.addEventListener('uk:consent-updated', function (e) {
    if (e.detail && typeof e.detail.analytics === 'boolean') consentUpdate = e.detail.analytics;
    tagInapp();
  });
  document.addEventListener('visitorConsentCollected', tagInapp);
  var inappAttempts = 0;
  (function attemptInapp() { tagInapp(); if (!sentInapp && ++inappAttempts < 10) setTimeout(attemptInapp, 2000); })();

  function atcSource(atc) {
    // el orden importa: cart-bar vive DENTRO de product-info — evaluar sticky primero
    return atc.hasAttribute('data-cart-bar-add-to-cart') || atc.closest('cart-bar') ? 'sticky-bar'
      : atc.closest('[data-cart-upsell],.product-upsell__holder,[data-upsell-holder]') ? 'upsell'
      : atc.closest('.product-grid-item') ? 'quick-add'
      : atc.closest('.popup-quick-view') ? 'quick-view'
      : atc.closest('product-info') ? 'pdp-form' : 'other';
  }
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var wa = t.closest('a[href*="wa.me"]');
    if (wa) {
      var tagged = wa.closest('[data-wa-source]');
      var src = (tagged && tagged.getAttribute('data-wa-source'))
        || (wa.closest('.whatsapp-float') ? 'fab'
        : wa.closest('.cart-drawer, [data-cart-drawer]') ? 'cart'
        : wa.closest('.size-finder, [data-size-finder-result]') ? 'size-finder'
        : tpl);
      track('whatsapp_click', { source: src });
    }
    var atc = t.closest('[data-add-to-cart],[data-cart-bar-add-to-cart],[data-cart-upsell-add]');
    if (atc && !atc.disabled && atc.getAttribute('aria-disabled') !== 'true') track('atc_click', { source: atcSource(atc) });
    if (t.closest('.size-finder-trigger')) track('view_size_guide', { source: tpl });
    if (t.closest('[data-size-rescue] a[href*="/products/"]')) track('alternative_click', { source: 'size-rescue' });
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-perso-toggle]') && t.checked) track('perso_toggle_open', { source: tpl });
    if (!t.matches('[data-single-option-selector]') || (t.type === 'radio' && !t.checked)) return;
    var fs = t.closest('fieldset');
    var name = (fs && fs.querySelector('legend') ? fs.querySelector('legend').textContent : '') + ' ' + (t.name || '') + ' ' + (t.getAttribute('aria-label') || '');
    if (!/talla|size/i.test(name)) return;
    track('select_size', { source: tpl, size: String(t.value) });
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-size-finder-form]')) track('size_finder_use', { source: tpl });
  }, true);
  document.addEventListener('uk:cart-add-result', function (e) {
    var d = e.detail || {};
    var params = { source: d.source || 'pdp-form' };
    if (d.variant_id) params.variant_id = String(d.variant_id);
    if (d.quantity) params.quantity = Number(d.quantity);
    if (typeof d.status === 'number') params.status = d.status;
    track(d.ok ? 'add_to_cart_success' : 'add_to_cart_error', params);
    if (d.ok && d.personalized) track('personalization_complete', { source: params.source }); // solo booleano, sin el texto
  });
})();
